// extracted by css-extract-rspack-plugin
export default {"cls1":"OverlappingAvatars-cls1_LkK","cls2":"OverlappingAvatars-cls2_0_j OverlappingAvatars-cls1_LkK"};